import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function TestResult() {
  const [testResults, setTestResults] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  
  useEffect(() => {
    // 首先尝试从路由状态获取结果
    if (location.state && location.state.testResults) {
      setTestResults(location.state.testResults);
      setLoading(false);
      return;
    }
    
    // 如果没有路由状态数据，尝试从本地存储获取
    try {
      const storedResultsJson = localStorage.getItem('testResults');
      if (storedResultsJson) {
        const storedResults = JSON.parse(storedResultsJson);
        // 获取最近的一个测试结果
        if (storedResults.length > 0) {
          setTestResults(storedResults[storedResults.length - 1]);
        }
      }
    } catch (err) {
      console.error("Error loading test results:", err);
    } finally {
      setLoading(false);
    }
  }, [location]);
  
  // 获取基于分数的反馈
  const getFeedbackMessage = (score) => {
    if (score >= 80) {
      return "You have excellent social intelligence! You demonstrate a strong ability to navigate complex social situations with empathy and insight. Your responses show that you understand subtle social cues and know how to respond appropriately in various contexts.";
    } else if (score >= 60) {
      return "You have good social awareness and can handle most social situations effectively. You understand the importance of empathy and communication in social interactions. With some practice, you can further enhance your social intelligence skills.";
    } else if (score >= 40) {
      return "You have a solid foundation in social skills but may encounter challenges in more complex situations. By consciously practicing empathy and attentive listening, you can significantly improve your social intelligence.";
    } else {
      return "You have areas where you can develop your social intelligence. Many social skills can be learned through practice and observation. Focus on empathy, active listening, and understanding different perspectives to improve your social interactions.";
    }
  };
  
  if (loading) {
    return (
      <div className="loading-indicator">
        <div className="spinner"></div>
        <p>Loading test results...</p>
      </div>
    );
  }
  
  if (!testResults) {
    return (
      <div className="no-results-container">
        <h2>No Test Results</h2>
        <p>No test results found. Please complete a test first.</p>
        <div className="action-buttons">
          <Link to="/full-test" className="primary-button">Take Full Test</Link>
          <Link to="/sequential-test" className="secondary-button">Take Six Topic Test</Link>
          <Link to="/scenarios" className="secondary-button">Browse Scenarios</Link>
        </div>
      </div>
    );
  }
  
  const { percentageScore } = testResults;
  const feedbackMessage = getFeedbackMessage(percentageScore);
  const isSequentialTest = location.state?.fromSequentialTest || false;
  
  return (
    <div className="scenario-detail-container test-result-container">
      <h1>Your Test Results</h1>
      
      <div className="score-display">
        <div className="score-circle">
          <div className="score-number">{testResults.percentageScore}<span className="score-suffix">%</span></div>
          <div className="score-label">Score</div>
        </div>
      </div>
      
      <div className="result-feedback">
        <h2>Your Social Intelligence Assessment</h2>
        <p>{feedbackMessage}</p>
      </div>
      
      <div className="action-section">
        <h3>Want to improve your skills?</h3>
        <p>Try more tests or explore our advanced scenarios to enhance your social intelligence.</p>
        
        <div className="action-buttons">
          {isSequentialTest ? (
            <Link to="/sequential-test" className="primary-button">Take Test Again</Link>
          ) : (
            <Link to="/full-test" className="primary-button">Take Test Again</Link>
          )}
          <Link to="/advanced-scenarios" className="secondary-button">Explore Advanced Scenarios</Link>
          <Link to="/" className="secondary-button">Return to Home</Link>
        </div>
      </div>
    </div>
  );
}

export default TestResult; 